import React from 'react';
import PropTypes from 'prop-types';

import { hasRoleAnonymous } from 'common/userRoles';

import SrBox from 'client/components/SrBox';
import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

const SrGetStartedBuyerSideAgent = ({ location, locationQuery, currentUser }) => {
  return (
    <div className="page-start">
      <div className="startTouring">
        <div className="progressBarContainer">
          <div className="progressBar" style={{ width: '15%' }} />
        </div>
        <Navbar
          redirectLogoTo="/"
          leftButton={
            <SrLink className="link back" to="/feed" restoreScrollPosition redirectToLastLocation />
          }
        />
        <div className="stepContainer">
          <SrBox maxWidth="450px" margin="0 auto" textAlign="center">
            <SrBox height="14px" />
            <h1>First, let us know who you are</h1>
            <SrBox height="24px" />
            <ButtonDeprecated
              href={
                hasRoleAnonymous(currentUser.roles)
                  ? `/start${location.search}`
                  : `/listing/${locationQuery.listingId}?showSelfShowingSteps=true`
              }
            >
              renter
            </ButtonDeprecated>
            <SrBox height="16px" />
            <ButtonDeprecated href={`/signup-buyer-agent${location.search}`}>
              agent
            </ButtonDeprecated>
          </SrBox>

          {hasRoleAnonymous(currentUser.roles) && (
            <div className="onboardingLinkContainer">
              <SrLink to={`/login${location.search}`}>
                Already have an account? Log in here →
              </SrLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

SrGetStartedBuyerSideAgent.propTypes = {
  location: PropTypes.object.isRequired,
  locationQuery: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
};

SrGetStartedBuyerSideAgent.displayName = 'SrGetStartedBuyerSideAgent';

export default SrGetStartedBuyerSideAgent;
